import { render, staticRenderFns } from "./DossierActions.vue?vue&type=template&id=2c0b8918&scoped=true"
import script from "./DossierActions.vue?vue&type=script&lang=ts"
export * from "./DossierActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0b8918",
  null
  
)

export default component.exports